import styled from '@emotion/styled';
// Theme 타입을 받아오는 함수 정의 (선택적, 테마 사용 방식에 따라 조정)
const getThemeProp = (prop)=>(props)=>props.theme[prop];
// CSS 변수를 사용하는 스타일드 컴포넌트 정의
export const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  /* 기본 높이 설정은 유지하되, VSCode 환경에서는 auto로 변경 */
  min-height: 100vh;
  height: 100%; /* 웹 환경 기본값 */
  width: 100%;
  margin: 0 auto;
  background-color: var(--theme-bg, ${getThemeProp('background')});
  color: var(--theme-text, ${getThemeProp('text')});
  transition: background-color 0.2s ease, color 0.2s ease;
  position: relative;
  overflow-x: hidden; /* 가로 스크롤 방지 */
  
  /* 기본 모바일 레이아웃은 단일 컬럼으로 설정 */
  display: flex;
  flex-direction: column;
  
  /* 모바일에서만 하단 패딩 적용 */
  @media (max-width: calc(${({ theme })=>theme.breakpoints.sm} - 1px)) {
    padding-bottom: calc(3.25rem + env(safe-area-inset-bottom, 0px));
  }
  
  /* 태블릿/데스크탑 화면에서는 그리드로 전환 */
  @media (min-width: ${({ theme })=>theme.breakpoints.sm}) {
    display: grid;
    grid-template-columns: var(--grid-template-columns, 68px 1fr auto); /* CSS 변수로 동적 제어 */
    grid-template-areas: "sidebar main rightsidebar";
    grid-template-rows: 1fr; /* 그리드 행이 컨텐츠에 맞게 늘어나도록 */
    gap: 0; /* 그리드 아이템 간 간격 제거 */
    align-items: stretch; /* 모든 그리드 아이템이 전체 높이를 차지하도록 */
  }
  
  /* 태블릿 화면 */
  @media (min-width: ${({ theme })=>theme.breakpoints.sm}) and (max-width: calc(${({ theme })=>theme.breakpoints.lg} - 1px)) {
    grid-template-columns: var(--grid-template-columns, 68px 1fr auto); /* CSS 변수로 동적 제어 */
    gap: 0; /* 그리드 아이템 간 간격 제거 */
  }
  
  /* 큰 화면 (1280px 이상) */
  @media (min-width: ${({ theme })=>theme.breakpoints.lg}) {
    grid-template-columns: var(--grid-template-columns, 275px 1fr auto); /* CSS 변수로 동적 제어 */
    gap: 0; /* 그리드 아이템 간 간격 제거 */
  }
  
  
  /* VSCode 환경 조건부 스타일링 */
  ${(props)=>props.isVSCode && `
    height: auto;
    min-height: 0;
    max-width: 100%;
    overflow: visible !important;

    body.vscode-dark & {
      background-color: var(--vscode-editor-background, ${getThemeProp('background')});
      color: var(--vscode-editor-foreground, ${getThemeProp('text')});
    }

    /* LayoutContainer 자체의 스크롤바만 숨김 */
    &::-webkit-scrollbar {
      display: none;
    }
    scrollbar-width: none; /* Firefox */

    /* 스크롤바 숨김 규칙 제거됨 */
  `}

  /* 강의 모드 스타일 */
  ${(props)=>(props.isLectureMode || props.isFullScreenMode) && `
    /* 풀스크린/강의 모드일 때 RightSidebarContainer를 강제로 숨기는 규칙 제거 */
    /* 
    ${RightSidebarContainer} {
      display: none !important;
    } 
    */

    @media (min-width: ${({ theme })=>theme.breakpoints.sm}) {
        /* 사이드바 및 오른쪽 사이드바 숨김 (너비 0 또는 display none) */
        /* MainContent가 전체 너비 차지하도록 그리드 조정 */
        grid-template-columns: 1fr; /* 메인 콘텐츠만 전체 너비 */
        grid-template-areas: "main"; /* 메인 콘텐츠만 사용 */
        
        /* 강의 모드 또는 전체 화면 모드일 때 MainContent 스타일 조정 */
        ${MainContent} { 
            border-left: none; /* 왼쪽 테두리 제거 */
            border-right: none; /* 오른쪽 테두리도 제거 */
            /* max-width: none; */ /* 필요시 최대 너비 제한 해제 */
        }
        /* 
          SidebarContainer와 RightSidebarContainer는 MainLayout.tsx에서 
          이미 조건부 렌더링으로 숨겨지므로, 여기서는 MainContent가 
          해당 영역을 차지하도록 그리드 설정만 변경합니다.
        */
    }
  `}
`;
export const SidebarContainer = styled.div`
  /* 모바일에서는 기본적으로 숨김 처리 */
  display: none;
  visibility: hidden;
  width: 0;
  height: 0;
  opacity: 0;
  position: absolute;
  left: -9999px;
  top: -9999px;
  pointer-events: none;
  
  @media (min-width: ${({ theme })=>theme.breakpoints.sm}) {
    display: grid;
    visibility: visible;
    width: 68px;
    height: 100vh;
    opacity: 1;
    position: sticky;
    left: unset;
    top: 0;
    pointer-events: auto;
    grid-area: sidebar;
    z-index: 5;
    border-right: 1px solid var(--theme-border, ${({ theme })=>theme.border});
    overflow: visible;
    padding: 0;
    align-self: stretch; /* 그리드 높이 전체를 차지하도록 */
  }
  
  @media (min-width: ${({ theme })=>theme.breakpoints.lg}) {
    width: 275px;
    padding: 0;
  }
  
  /* VSCode 환경에서는 추가 스타일 */
  &.vscode-sidebar {
    background: transparent;
    border-right: 1px solid var(--vscode-editorGroup-border);
    overflow: visible;
    
    /* 모바일에서는 무조건 숨김 처리 */
    @media (max-width: calc(${({ theme })=>theme.breakpoints.sm} - 1px)) {
      display: none !important;
      visibility: hidden !important;
      width: 0 !important;
      height: 0 !important;
      opacity: 0 !important;
      position: absolute !important;
      left: -9999px !important;
      top: -9999px !important;
      pointer-events: none !important;
    }
  }
`;
export const FixedInnerSidebar = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 68px;
  height: 100vh;
  overflow-y: auto;
  background-color: var(--theme-paper, ${({ theme })=>theme.paper});
  z-index: 10;
  box-sizing: border-box;
  padding: 0;

  @media (min-width: ${({ theme })=>theme.breakpoints.lg}) {
    width: 275px;
  }

  &.vscode-fixed-inner-sidebar {
    body.vscode-dark & {
      background-color: var(--vscode-sideBar-background, var(--theme-paper, ${({ theme })=>theme.paper}));
      color: var(--vscode-sideBar-foreground);
    }
    body.vscode-light & {
      background-color: var(--vscode-sideBar-background, var(--theme-paper, ${({ theme })=>theme.paper}));
      color: var(--vscode-sideBar-foreground);
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
  }

  &:not(.vscode-fixed-inner-sidebar)::-webkit-scrollbar {
    width: 4px;
  }
  &:not(.vscode-fixed-inner-sidebar)::-webkit-scrollbar-track {
    background: var(--theme-paper-light, ${({ theme })=>theme.paperLight});
    border-radius: 10px;
  }
  &:not(.vscode-fixed-inner-sidebar) {
    scrollbar-width: thin;
    scrollbar-color: var(--theme-secondary, ${({ theme })=>theme.secondary})
                     var(--theme-paper-light, ${({ theme })=>theme.paperLight});
  }
`;
export const MainContent = styled.main`
  grid-area: main;
  width: 100%;
  min-height: 100vh; /* 최소 높이는 유지 */
  background-color: var(--theme-paper, ${getThemeProp('paper')});
  position: relative;
  overflow-x: hidden;
  z-index: 1;
  /* 기본적으로 세로 스크롤을 허용 */
  overflow-y: auto; /* 웹 환경 기본 */
  box-sizing: border-box; /* padding이 높이에 포함되도록 보장 */
  
  /* 모바일에서는 테두리 없음 */
  @media (max-width: calc(${({ theme })=>theme.breakpoints.sm} - 1px)) {
    border-left: none;
    border-right: none;
    /* 모바일 하단 네비게이션 바 + 버튼 transform + 안전 영역 고려한 공간 확보 */
    padding-bottom: calc(4.5rem + env(safe-area-inset-bottom, 0px)); 
  }
  
  /* 태블릿 이상에서만 테두리 적용 */
  @media (min-width: ${({ theme })=>theme.breakpoints.sm}) {
    border-left: 1px solid var(--theme-border, ${getThemeProp('border')});
    border-right: none; /* RightSidebarContainer가 처리 */
    padding-bottom: 0; /* 데스크탑에서는 하단 여백 제거 */
  }
  
  /* VSCode 환경 조건부 스타일링 */
  ${(props)=>props.isVSCode && `
    min-height: 0; /* 최소 높이 제한 제거 */
    /* overflow-y: visible; 제거됨 - VSCode 환경에서도 스크롤은 MainContent가 담당 */

    /* VSCode 다크모드 배경/테두리 (VSCode 변수 직접 사용) */
    body.vscode-dark & {
      background-color: var(--vscode-editor-background, ${getThemeProp('paper')});
      border-right-color: var(--vscode-editorGroup-border, ${getThemeProp('border')});
      border-left-color: var(--vscode-editorGroup-border, ${getThemeProp('border')});
    }

    /* VSCode 환경의 모바일 뷰 스타일 */
    @media (max-width: calc(${({ theme })=>theme.breakpoints.sm} - 1px)) {
        padding-bottom: calc(3.25rem + env(safe-area-inset-bottom, 0px)) !important; /* 하단 여백 강제 적용 */
        overflow-y: auto !important; /* 내부 스크롤 강제 적용 */
        /* 스크롤바 thin 스타일 (WebKit) */
        &::-webkit-scrollbar {
          width: 4px;
        }
        &::-webkit-scrollbar-track {
          background: transparent; /* VSCode 배경 투명 */
        }
        /* 스크롤바 thin 스타일 (Firefox) */
        scrollbar-width: thin;
    }
    
    /* VSCode 환경의 태블릿/데스크탑 뷰 스타일 */
    @media (min-width: ${({ theme })=>theme.breakpoints.sm}) {
       overflow-y: auto; /* 스크롤 가능 */
       /* 스크롤바 thin 스타일 (WebKit) */
       &::-webkit-scrollbar {
         width: 4px; 
       }
       &::-webkit-scrollbar-track {
         background: transparent; /* VSCode 배경 투명 */
       }
       /* 스크롤바 thin 스타일 (Firefox) */
       scrollbar-width: thin;
       scrollbar-color: transparent transparent; /* VSCode 색상 투명 */
    }
  `}
  
  /* 스크롤바 스타일링 (웹 환경용) - VSCode 조건부 밖으로 이동 */
  body:not(.vscode-dark):not(.vscode-light) & { // 웹 환경 타겟
    &::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    &::-webkit-scrollbar-track {
      background: var(--theme-paper-light, ${getThemeProp('paperLight')});
      border-radius: 10px;
    }
    /* Firefox 스크롤바 스타일링 (웹 환경용) */
    scrollbar-width: thin;
    scrollbar-color: var(--theme-secondary, ${getThemeProp('secondary')})
                     var(--theme-paper-light, ${getThemeProp('paperLight')});
  }
`;
export const RightSidebarContainer = styled.div`
  display: ${({ $isVisible })=>$isVisible ? 'flex' : 'none'};
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  z-index: 5;
  background-color: var(--theme-paper, ${({ theme })=>theme.paper});
  overflow: hidden; /* visible에서 다시 hidden으로 변경하여 스크롤을 내부에서 처리 */
  flex-direction: column; /* 세로 방향 flexbox로 설정 */
  
  /* 왼쪽 경계선을 리사이즈 핸들로 */
  &::before {
    content: '';
    position: absolute;
    left: -1px;
    top: 0;
    bottom: 0;
    width: 6px;
    background: transparent;
    cursor: col-resize;
    z-index: 10;
    transition: all 0.2s ease;
    border-left: 2px solid transparent;
    
    /* 데스크탑에서는 hover 시에만 표시 */
    @media (hover: hover) and (pointer: fine) {
      &:hover {
        background: rgba(59, 130, 246, 0.1);
        border-left-color: var(--theme-primary, ${({ theme })=>theme.primary});
      }
    }
    
    /* 터치 디바이스에서는 더 명확하게 보이도록 */
    @media (hover: none) and (pointer: coarse) {
      background: rgba(59, 130, 246, 0.1);
      border-left: 2px solid rgba(59, 130, 246, 0.3);
      
      &:active {
        background: rgba(59, 130, 246, 0.2);
        border-left-color: var(--theme-primary, ${({ theme })=>theme.primary});
      }
    }
  }
  
  /* 리사이즈 핸들에 점선 표시자 추가 */
  &::after {
    content: '';
    position: absolute;
    left: 1px;
    top: 50%;
    transform: translateY(-50%);
    width: 2px;
    height: 20px;
    background-image: repeating-linear-gradient(
      to bottom,
      transparent,
      transparent 2px,
      var(--theme-text-secondary, rgba(107, 114, 128, 0.6)) 2px,
      var(--theme-text-secondary, rgba(107, 114, 128, 0.6)) 4px
    );
    opacity: 0;
    transition: opacity 0.2s ease;
    pointer-events: none;
    z-index: 11;
    
    /* 데스크탑에서는 hover 시에만 표시 */
    @media (hover: hover) and (pointer: fine) {
      opacity: 0;
    }
  }
  
  &:hover::after {
    @media (hover: hover) and (pointer: fine) {
      opacity: 1;
    }
  }
  
  &.resizing::after {
    opacity: 1;
  }
  
  &.resizing::before {
    background: rgba(59, 130, 246, 0.3);
    border-left-color: var(--theme-primary, ${({ theme })=>theme.primary});
    width: 6px;
  }
  
  &.resizing {
    box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
  }
  
  /* VSCode 다크모드에서 배경색 설정 */
  .vscode-dark & {
    background-color: var(--vscode-sideBar-background, var(--theme-paper, ${({ theme })=>theme.paper}));
    border-left-color: var(--vscode-editorGroup-border);
  }
   
  /* 스크롤바 스타일링 (웹/VSCode 공통 thin 스타일) */
  &::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
    body:not(.vscode-dark):not(.vscode-light) & {
      background: var(--theme-paper-light, ${({ theme })=>theme.paperLight});
      border-radius: 10px;
    }
  }
  /* Firefox 스크롤바 스타일 */
  scrollbar-width: thin;
  body:not(.vscode-dark):not(.vscode-light) & {
    scrollbar-color: var(--theme-secondary, ${({ theme })=>theme.secondary})
                     var(--theme-paper-light, ${({ theme })=>theme.paperLight});
  }

  @media (max-width: calc(${({ theme })=>theme.breakpoints.sm} - 1px)) {
    display: none !important;
  }
`;
// 리사이즈 핸들 추가
export const ResizeHandle = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  cursor: col-resize;
  background: transparent;
  z-index: 10;
  
  &:hover {
    background: var(--theme-border, ${({ theme })=>theme.border});
  }
  
  &:active {
    background: var(--theme-primary, ${({ theme })=>theme.primary});
  }
`;
export const MobileNavigation = styled.div`
  display: block;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 50;
  background-color: var(--theme-paper, ${({ theme })=>theme.paper});
  border-top: 1px solid var(--theme-border, ${({ theme })=>theme.border});
   
  @media (min-width: ${({ theme })=>theme.breakpoints.sm}) {
    display: none;
  }
  
  /* VSCode 환경에서는 추가 스타일 */
  &.vscode-mobile-nav {
    .vscode-dark & {
      background-color: var(--vscode-editor-background);
      border-top-color: var(--vscode-editorGroup-border);
    }
  }
`;
// VSCode 환경 전용 글로벌 스타일 정의는 제거됨 (prop 기반 스타일링으로 대체)
// --- SidebarToggleButton 스타일 정의 추가 --- 
export const SidebarToggleButton = styled.button`
  position: fixed;
  bottom: 1rem; // 하단에 위치
  left: 1rem; // 좌측에 위치
  z-index: 100; // 다른 요소 위에 보이도록
  padding: var(--theme-spacing-xs, 0.5rem);
  background-color: var(--theme-paper-hover, ${({ theme })=>theme.paperHover});
  border: 1px solid var(--theme-border, ${({ theme })=>theme.border});
  border-radius: var(--theme-radius-md, 0.375rem);
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex; // 아이콘 정렬용
  align-items: center;
  justify-content: center;
  color: var(--theme-text, ${({ theme })=>theme.text});
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  &:hover {
    background-color: var(--theme-paper-active, ${({ theme })=>theme.paperActive});
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transform: translateY(-1px);
  }

  /* 아이콘 크기 및 스타일 */
  svg {
    width: 1.25rem; // 20px
    height: 1.25rem;
  }
`;
// --- 모바일 오른쪽 사이드바 스타일 --- 
export const MobileRightSidebarOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 50;
  visibility: ${({ $isOpen })=>$isOpen ? 'visible' : 'hidden'};
  transition: visibility 0.3s ease;
  overflow: hidden;
  
  @media (min-width: ${({ theme })=>theme.breakpoints.sm}) {
    display: none;
  }
`;
export const MobileRightSidebarBackdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: ${({ $isOpen })=>$isOpen ? 1 : 0};
  transition: opacity 0.3s ease;
`;
export const MobileRightSidebarPanel = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  max-width: 400px;
  background-color: var(--theme-paper, ${({ theme })=>theme.paper});
  transform: ${({ $isOpen })=>$isOpen ? 'translateX(0)' : 'translateX(100%)'};
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  border: none;
  outline: none;
  
  /* VSCode 다크모드에서 배경색 설정 */
  .vscode-dark & {
    background-color: var(--vscode-sideBar-background, var(--theme-paper, ${({ theme })=>theme.paper}));
  }
`;
// 채팅 헤더 스타일 추가
export const ChatHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--theme-border, ${({ theme })=>theme.border});
  background-color: var(--theme-paper, ${({ theme })=>theme.paper});
  flex-shrink: 0;
`;
export const ChatTabContainer = styled.div`
  display: flex;
  gap: 4px;
`;
export const ChatTabButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: none;
  border-radius: 6px;
  background-color: ${(props)=>props.active ? 'var(--theme-primary, #10b981)' : 'transparent'};
  color: ${(props)=>props.active ? 'white' : 'var(--theme-text, #111827)'};
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;

  &:hover {
    background-color: ${(props)=>props.active ? 'var(--theme-primary, #10b981)' : 'var(--theme-hover, #f3f4f6)'};
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;
export const ChatContentContainer = styled.div`
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;
